/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { MPIStrictHttpResponse } from '../../mpi-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PatientSummaryModel } from '../../models/patient-summary-model';

export interface ConsumerPatientSummaryGet$Params {
}

export function consumerPatientSummaryGet(http: HttpClient, rootUrl: string, params?: ConsumerPatientSummaryGet$Params, context?: HttpContext): Observable<MPIStrictHttpResponse<PatientSummaryModel>> {
  const rb = new RequestBuilder(rootUrl, consumerPatientSummaryGet.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as MPIStrictHttpResponse<PatientSummaryModel>;
    })
  );
}

consumerPatientSummaryGet.PATH = '/Consumer/PatientSummary';
